/* eslint-disable react/no-unescaped-entities */
import PageNav from "./components/PageNav";
import { useState, useEffect, useRef } from "react";
import { UseUserAuth } from "./context/UseAuthContext";
import { CheckCircleIcon, RocketLaunchIcon, PhotoIcon, XMarkIcon, PlusIcon } from "@heroicons/react/20/solid";
import AlertCredit from "./AlertCredit";
import Modal from "./Modal";
import InputConfirmation from "./UserInputDialogueBox";
import MissingInput from "./MissingInputDialogueBox";
import { Hourglass } from 'react-loader-spinner';
import { generateSlug } from './utils';
import { useNavigate } from "react-router-dom";
import app from "./context/Firebase";
import { getAnalytics, logEvent } from "firebase/analytics";

function CreateEssential() {
  const [bookId, setBookId] = useState(null); // Define userQueryID state
  const [story, setStory] = useState("");
  const [paragraphs, setParagraphs] = useState("");
  const [storyTitle, setStoryTitle] = useState("");
  const { user } = UseUserAuth();
  const [isSaved, setIsSaved] = useState(false); // Track save status at parent level
  const [showTutorialBanner, setShowTutorialBanner] = useState(true); // Add this line
  const navigate = useNavigate();

  console.log("story top", story)

  // Create a Message component
const Message = ({ message, type, onClose }) => {
  return (
    <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 p-4 rounded-md shadow-lg ${
      type === 'error' ? 'bg-red-50 text-red-800' : 
      type === 'success' ? 'bg-green-50 text-green-800' : 
      'bg-blue-50 text-blue-800'
    }`}>
      <div className="flex items-center">
        <p className="text-sm font-medium">{message}</p>
        <button 
          onClick={onClose}
          className="ml-4 text-gray-400 hover:text-gray-500"
        >
          ×
        </button>
      </div>
    </div>
  );
};

  // In your main component, add state for the message
const [message, setMessage] = useState(null);

  async function handleSave() {
    if (!bookId) {
      setMessage({
        text: "No story ID found. Please generate a story first.",
        type: "error"
      });
      return false;
    }

    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${process.env.REACT_APP_BACKEND}/user/saveEssentialStory`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken,
        },
        body: JSON.stringify({
          bookId,
          paragraphs,
          storyTitle
        }),
      });
      
      if (response.ok) {
        setIsSaved(true); // Set save state to true after successful save
        //alert("Story saved successfully!");
        const resp = await response.json();
        const storyTitle = resp['storyTitle']
        const slug = generateSlug(storyTitle);
        const bookID = resp['bookId'];
        const formattedStory = resp['formattedStory'];
        const imageNum = 'None';
        //console.log("lib, bookdata", bookData);
        navigate(`/library/essential/${slug}/edit`, { state:  { 
          bookID,
          storyTitle,
          formattedStory,
          imageNum
        //  fromCreate: true // Flag to show we're coming from creation
        } });
        return true;
      } else {
        //alert("Failed to save story. Please try again.");
       // return false;

       // Handle different error status codes
    const errorText = await response.text();
    
    switch (response.status) {
      case 400:
        if (errorText.includes('title')) {
          setMessage({
            text: "Please provide a story title.",
            type: "error"
          });
        } else if (errorText.includes('paragraph')) {
          setMessage({
            text: "Please ensure all story paragraphs have content.",
            type: "error"
          });
        }
        break;


      case 403:
    /*    if (errorText.includes('inappropriate')) {
          alert(errorText);
        } else if (errorText.includes('10 paragraph')) {
          alert("Your story must contain exactly 10 paragraphs.");
        } else {
          alert("Your story content needs adjustment. Please review and try again.");
        }
        break; */
        if (errorText.includes('inappropriate word')) {
          setMessage({
            text: errorText,
            type: "error"
          });
        } else if (errorText.includes('10 paragraph')) {
          setMessage({
            text: "Your story must contain exactly 10 paragraphs.",
            type: "error"
          });
        }
        break;
        
      case 404:
        if (errorText.includes('no credit')) {
          setMessage({
            text: "You don't have enough credits. Please purchase more credits to save your story.",
            type: "error"
          });
        }
        break;


      case 500:
        alert("We're experiencing technical difficulties. Please try again later.");
        break;

      default:
        alert("Failed to save story. Please try again.");
    }
    return false;

  }
      
    } catch (error) {
      console.error("Error saving story:", error);
      alert("Error saving story. Please try again.");
      return false;
    }
  }

  function handleRewrite() {
    setStory("");
    setParagraphs("");
    setStoryTitle("");
    setBookId(null);
    setIsSaved(false);
  }

  return (
    <div>
      <PageNav className="absolute inset-x-0 top-0 z-50" />
        {/* Tutorial Banner - Full Width */}
{showTutorialBanner && (
  <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-blue-700">
              First time creating a photo story? 
              <a 
                href="/tutorials" 
                target="_blank"
                className="font-medium underline hover:text-blue-600 ml-1"
              >
                Watch our 3-minute tutorial →
              </a>
            </p>
          </div>
        </div>
        <button
          onClick={() => setShowTutorialBanner(false)}
          className="text-blue-400 hover:text-blue-500 flex-shrink-0"
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
)}
      <Heading />
       
      <Generate />
      <MyForm
        setBookId={setBookId}
        setStory={setStory}
        setParagraphs={setParagraphs}
        setStoryTitle={setStoryTitle} 
        setMessage={setMessage}  // Add this line
      />
      <StoryEditor 
        story={story}
        setStory={setStory}
        storyTitle={storyTitle}
        setStoryTitle={setStoryTitle}
        paragraphs={paragraphs}
        setParagraphs={setParagraphs}
        onSave={handleSave}
        onRewrite={handleRewrite}
        isSaved={isSaved}
      />
      {message && (
      <Message 
        message={message.text}
        type={message.type}
        onClose={() => setMessage(null)}
      />
    )}
    </div>
  );
}
    
// Character Photo Upload Component
function CharacterPhotoUpload({ characters, setCharacters, setMessage }) {
  const MAX_CHARACTERS = 6;

  // Photo quality guidelines component
  const PhotoGuidelines = () => (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-semibold text-yellow-800">
            Photo Quality Requirements - Please Read Carefully!
          </h3>
          <div className="mt-2 text-sm text-yellow-700">
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Clear, well-lit photos only</strong> - No blurry, dark, or low-resolution images</li>
              <li><strong>Single person only</strong> - No group photos or multiple people in frame or props such as toys, stuffed animals, or other objects in the frame</li>
              <li><strong>Face clearly visible</strong> - Avoid sunglasses, masks, or obscured faces</li>
              <li><strong>Good lighting</strong> - Natural daylight works best</li>
              <li><strong>High resolution</strong> - At least 300x300 pixels for best results</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );

  // Photo examples component (you could add actual example images)
  const PhotoExamples = () => (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
      <h4 className="text-sm font-semibold text-green-800 mb-2">✅ Good Photo Examples:</h4>
      <div className="text-sm text-green-700 space-y-1">
        <p>• Portrait photo with clear face and good lighting</p>
        <p>• Single person in frame, well-focused</p>
        <p>• Neutral background preferred</p>
        <p>• Person looking at camera</p>
      </div>
      
      <h4 className="text-sm font-semibold text-red-800 mb-2 mt-4">❌ Avoid These:</h4>
      <div className="text-sm text-red-700 space-y-1">
        <p>• Blurry or out-of-focus images</p>
        <p>• Group photos with multiple people</p>
        <p>• Dark or poorly lit photos</p>
        <p>• Side profiles or faces turned away</p>
        <p>• Photos with sunglasses or face coverings</p>
      </div>
    </div>
  );

  const handleAddCharacter = () => {
    if (characters.length >= MAX_CHARACTERS) return;
    
    const newCharacter = {
      id: Date.now(),
      name: '',
      relationship: characters.length === 0 ? 'main' : '',
      photo: null,
      photoPreview: null,
      gender: 'girl'
    };
    setCharacters([...characters, newCharacter]);
  };

  const handleRemoveCharacter = (id) => {
    if (characters.length <= 1) return;
    setCharacters(characters.filter(char => char.id !== id));
  };

  const handleCharacterChange = (id, field, value) => {
    setCharacters(characters.map(char => 
      char.id === id ? { ...char, [field]: value } : char
    ));
  };

  const handlePhotoUpload = (id, file) => {
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      setMessage({
        text: "Please upload only image files.",
        type: "error"
      });
     
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setMessage({
        text: "Image size must be less than 5MB",
        type: "error"
      });
      return;
    }
  
    const previewUrl = URL.createObjectURL(file);
  // Update both photo and photoPreview at the same time
  setCharacters(prevCharacters => 
    prevCharacters.map(char => 
      char.id === id 
        ? { ...char, photo: file, photoPreview: previewUrl }
        : char
    )
  );

 //   const previewUrl = URL.createObjectURL(file);
  //  handleCharacterChange(id, 'photo', file);
  //  handleCharacterChange(id, 'photoPreview', previewUrl);
  };

  return (
    <div className="bg-slate-50 p-6 rounded-lg mb-8">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Character Photos</h2>
          <p className="text-sm text-gray-600 mt-1">Add up to 6 characters with their photos</p>
        </div>
        <button
          type="button"
          onClick={handleAddCharacter}
          disabled={characters.length >= MAX_CHARACTERS}
          className={`inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold text-white ${
            characters.length >= MAX_CHARACTERS 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-indigo-600 hover:bg-indigo-500'
          }`}
        >
          <PlusIcon className="h-4 w-4" />
          Add Character ({characters.length}/{MAX_CHARACTERS})
        </button>
      </div>
   {/*   <PhotoGuidelines />
      <PhotoExamples /> */}

      {characters.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <PhotoIcon className="mx-auto h-12 w-12 text-gray-400" />
          <p className="mt-2">No characters added yet. Click "Add Character" to get started.</p>
        </div>
      ) : (
        <div className="space-y-6">
          {characters.map((character, index) => (
            <div key={character.id} className="bg-white p-6 rounded-lg border-2 border-gray-200">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-medium text-gray-900">
                  {character.name || `Character ${index + 1}`}
                  {index === 0 && <span className="ml-2 text-sm text-indigo-600">(Main Character)</span>}
                </h3>
                {characters.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveCharacter(character.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <XMarkIcon className="h-5 w-5" />
                  </button>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Character Name
                    </label>
                    <input
                      type="text"
                      value={character.name}
                      onChange={(e) => handleCharacterChange(character.id, 'name', e.target.value)}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter character name"
                      style={{ padding: "10px" }}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Relationship to Main Character
                    </label>
                    <select
                      value={character.relationship}
                      onChange={(e) => handleCharacterChange(character.id, 'relationship', e.target.value)}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    >
                      <option value="">Select relationship</option>
                      <option value="main">Main Character</option>
                      <option value="mother">Mother</option>
                      <option value="father">Father</option>
                      <option value="brother">Brother</option>
                      <option value="sister">Sister</option>
                      <option value="friend">Friend</option>
                      <option value="grandmother">Grandmother</option>
                      <option value="grandfather">Grandfather</option>
                      <option value="teacher">Teacher</option>
                      <option value="pet">Pet</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Gender
                    </label>
                    <select
                      value={character.gender}
                      onChange={(e) => handleCharacterChange(character.id, 'gender', e.target.value)}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    >
                      <option value="girl">Girl</option>
                      <option value="boy">Boy</option>
                      <option value="man">Man</option>
                      <option value="woman">Woman</option>
                      <option value="unknown">Unknown</option>

                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Character Photo
                  </label>
                  <div className="mt-2">
                    {character.photoPreview ? (
                      <div className="relative">
                        <img
                          src={character.photoPreview}
                          alt="Character preview"
                          className="w-full h-48 object-cover rounded-lg border-2 border-gray-200"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            handleCharacterChange(character.id, 'photo', null);
                            handleCharacterChange(character.id, 'photoPreview', null);
                          }}
                          className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                        >
                          <XMarkIcon className="h-4 w-4" />
                        </button>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          const input = document.createElement('input');
                          input.type = 'file';
                          input.accept = 'image/*';
                          input.onchange = (e) => handlePhotoUpload(character.id, e.target.files[0]);
                          input.click();
                        }}
                        className="cursor-pointer border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-indigo-500 transition-colors"
                      >
                        <PhotoIcon className="mx-auto h-12 w-12 text-gray-400" />
                        <p className="mt-2 text-sm text-gray-600">
                          Click to upload a photo
                        </p>
                        <p className="text-xs text-gray-400">
                          PNG, JPG up to 5MB<br/>
                          Clear, well-lit, single person only
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

    function StoryEditor({ story, setStory, storyTitle, setStoryTitle, paragraphs, setParagraphs, onSave, onRewrite, isSaved }) {
    
      return (
        <div className="max-w-3xl mx-auto mt-10 mb-20">
          {/* Title Editor */}
          <div className="mt-6">
            <label htmlFor="story-title" className="block text-sm font-medium text-gray-900">
              Story Title
            </label>
            <input
              type="text"
              id="story-title"
              className="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              value={storyTitle}
              onChange={(e) => setStoryTitle(e.target.value)}
              placeholder="Your story title will appear here"
              style={{ padding: "10px" }}
              disabled={!story || isSaved}
            />
          </div>
    
          {/* Paragraphs Editor */}
          <div className="mt-6">
            <label className="block text-sm font-medium text-gray-900">
              Story Content {paragraphs.length > 0 && `(${paragraphs.length} paragraphs)`}
            </label>
            
            {paragraphs.length > 0 ? (
              <div className="mt-2 space-y-4">
                {paragraphs.map((paragraph, index) => (
                  <div key={index} className="relative">
                    <label className="absolute left-2 top-2 text-sm font-medium text-gray-500">
                      {index + 1}.
                    </label>
                    <textarea
                      className="block w-full rounded-md border-0 py-1.5 pl-8 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={paragraph}
                      onChange={(e) => {
                        const newParagraphs = [...paragraphs];
                        newParagraphs[index] = e.target.value;
                        setParagraphs(newParagraphs);
                      }}
                      rows={3}
                      style={{ padding: "10px", paddingLeft: "2rem" }}
                      disabled={isSaved}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-4">
                Fill the form above and click Generate to create your story. Once generated, your story content will appear here and you can edit it if you'd like.
              </div>
            )}
          </div>
    
          {/* Action Buttons */}
          <div className="mt-6 flex gap-4 mb-10">
            <button
              className={`rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                story && !isSaved
                  ? "bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600" 
                  : "bg-indigo-300 cursor-not-allowed"
              }`}
              onClick={onSave}
              disabled={!story || isSaved}
            >
              {isSaved ? "Story Saved" : "Save Story"}
            </button>
            <button
              className={`rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                story && !isSaved
                  ? "bg-gray-600 hover:bg-gray-500 focus-visible:outline-gray-600" 
                  : "bg-gray-300 cursor-not-allowed"
              }`}
              onClick={onRewrite}
              disabled={!story || isSaved}
            >
              Rewrite Story
            </button>
          </div>
    
          {/* Success message */}
          {isSaved && (
            <div className="mt-2 text-sm text-green-600 flex items-center gap-2">
              <CheckCircleIcon className="h-5 w-5"/> 
              Story has been saved successfully. The story will now proceed for image generation.
            </div>
          )}
        </div>
      );
    }

function Heading() {
  const { user } = UseUserAuth();
  const [userName, setUserName] = useState("");
 // console.log("create user", user);

 const fetchUserName = async () => {
  try {
    const idToken = await user.getIdToken();
    const response = await fetch(`${process.env.REACT_APP_BACKEND}/user/getUserName`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: idToken,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch user name");
    }
    const data = await response.json();
    setUserName(data);
  } catch (error) {
    console.error("Error fetching user name:", error);
  }
};
useEffect(() => {
  if (user) {
    fetchUserName();
  }
}, [user]);

return (
  <div className="flex justify-center text-lg font-semibold p-4 box mt-2 text-center text-indigo-600 ">
    Welcome <br />
    {userName || (user ? (user.displayName ? user.displayName : user.email) : "Guest")}
  </div>
);
}

function Generate() {
  return (
    <div className=" flex bg-white px-4 py-2 lg:px-8">
      <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
        <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl text-center mb-4">
          Instructions:
        </h1>{" "}
     {/*}   <p className="mt-6 text-xl leading-8">
          Follow these simple steps to create your very own one-of-a-kind
          storybook
        </p> */}
        <div className="mt-8 max-w-2xl">
          <ul
            role="list"
            className="mt-8 max-w-2xl space-y-4 text-gray-600 text-justify"
          >
            
            <li className="flex gap-x-3">
              <CheckCircleIcon
                className="mt-1 h-5 w-5 flex-none text-indigo-600"
                aria-hidden="true"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Fill Details:{" "}
                </strong>
                Enter character name, gender and age group. Pick a moral value or describe desired storyline - or both.
              </span>
            </li>
            <li className="flex gap-x-3">
  <CheckCircleIcon
    className="mt-1 h-5 w-5 flex-none text-indigo-600"
    aria-hidden="true"
  />
  <span>
    <strong className="font-semibold text-gray-900">
      Add Characters:{" "}
    </strong>
    Upload photos and details for up to 6 characters. Main character photo is required. <strong>For best results: Upload clear, well-lit photos showing one person only. Avoid blurry, dark, or low-resolution images. </strong>
  </span>
</li>
            <li className="flex gap-x-3">
              <CheckCircleIcon
                className="mt-1 h-5 w-5 flex-none text-indigo-600"
                aria-hidden="true"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Story Generation:{" "}
                </strong>{" "}
                Wait 30-60 seconds after submission. Story will appear in editor below.
              </span>
            </li>

            <li className="flex gap-x-3">
              <CheckCircleIcon
                className="mt-1 h-5 w-5 flex-none text-indigo-600"
                aria-hidden="true"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Review and Edit:{" "}
                </strong>{" "}
                Once your story appears, you have three options:
                <ul className="mt-2 ml-4 space-y-1">
                  <li>• Press "Save Story" to accept the story as is and proceed to image creation</li>
                  <li>• Edit title and text to refine your story before saving</li>
                  <li>• Not happy with the story? Click "Rewrite Story" to generate a fresh version with your same inputs</li>
                </ul>
              </span>
            </li>



          </ul>
        </div>
      </div>
    </div>
  );
}

function MyForm({
  setBookId,
  setStory,
  setParagraphs,
  setStoryTitle,
  setMessage
}) {
  const [characters, setCharacters] = useState([]);
  //const [gender, setGender] = useState("girl");
  const [readerAgeGroup, setReaderAgeGroup] = useState('2-4years')
  const [description, setDescription] = useState("");
  const [moralValue, setMoralValue] = useState("");
  const { user } = UseUserAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false); // Set to true initially to show the modal
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  // const [creditPoints, setCreditPoints] = useState(0); // Initialize creditPoints state
  const [isMissingInputOpen, setIsMissingInputOpen] = useState(false);
 // const [gender, setGender] = useState("girl");
 // const [mainChrName, setMainChrName] = useState("");
 // const [appearanceValue, setAppearanceValue] = useState("photo_based");
  // Initialize with one character on component mount
  useEffect(() => {
    if (characters.length === 0) {
      setCharacters([{
        id: Date.now(),
        name: '',
        relationship: 'main',
        photo: null,
        photoPreview: null,
        gender: 'girl'
      }]);
    }
  }, []);


  async function pollBackendForResult(bookId) {
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND}/user/enhancedTextOutput`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
          },
          body: JSON.stringify({ bookId: bookId }),
        }
      );
      if (response.status === 404) {
        console.warn("Endpoint not ready yet. Retrying in 30 second...");
        setTimeout(() => pollBackendForResult(bookId), 30000);
        return;
      }
      const jsonString = await response.text();
      console.log("resp", response);
      console.log('jsonString', jsonString);
      const resultReady = jsonString.includes(bookId);
      console.log('resultReady', resultReady);
      const data = JSON.parse(jsonString);
      const userStory = data.story;
    
      const allParagraphs = userStory
        .split("\n")
        .filter((paragraph) => paragraph.trim() !== "");
      const unclean_paragraphs = allParagraphs.slice(1);
      // Remove numbers from paragraphs
      const paragraphs = unclean_paragraphs.map((paragraph) => {
        const cleanedText = paragraph.replace(/^\d+\.\s*/, "");
        return cleanedText;
      });
     
      //Extracting title
      //const titleMatch = userStory.match(/^Title: (.+)$/m);
      //const storyTitle = titleMatch ? titleMatch[1] : "";
          // Determine the format of the story
      const isOldFormat = userStory.startsWith('Title:');
      let storyTitle = '';
      //let splits = story.split('\n').filter(paragraph => paragraph.trim() !== '');
      if (isOldFormat) {
        // Extract the title using the old format
        const titleMatch = userStory.match(/^Title: (.+)$/m);
        storyTitle = titleMatch ? titleMatch[1] : '';
        // Remove the first line (title) from the paragraphs
        //splits = splits.slice(1);
      } else {
        // Extract the title from the first line for the new format
        const splits = userStory.split('\n').filter((paragraph) => paragraph.trim() !== '');
        storyTitle = splits[0].trim();
        if (storyTitle.startsWith('**Title:') && storyTitle.endsWith('**')) {
          storyTitle = storyTitle.replace(/^\*\*Title:\s*/, '').replace(/\*\*$/, '').trim();
        }
        else if (storyTitle.startsWith('**') && storyTitle.endsWith('**')) {
          storyTitle = storyTitle.replace(/\*\*/g, '').trim();
        }
        // Remove the title from the paragraphs
        //splits = splits.slice(1);
        // Remove non-alphanumeric characters from the start and end of the title
      storyTitle = storyTitle.replace(/^[^\w]+|[^\w]+$/g, '');
      console.log('paragraphs', paragraphs, 'storyTitle', storyTitle,'userStory', userStory )
      }

      if (resultReady){
        setParagraphs(paragraphs);
        setStoryTitle(storyTitle);
        setStory(userStory);
        setIsLoading(false);
      } else {
        // Continue polling every 30 seconds
        setTimeout(() => pollBackendForResult(bookId), 30000); // Poll every 30 seconds
      }
    } catch (error) {
      console.error("Error polling for result:", error);
      setTimeout(() => pollBackendForResult(bookId), 30000); // Poll every 30 seconds
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

      // Validate characters
      if (characters.length === 0) {
        setIsMissingInputOpen(true);
        return;
      }
      console.log('Characters:', characters);
      const mainCharacter = characters.find(char => char.relationship === 'main') || characters[0];
      console.log('Main character:', mainCharacter);
      console.log('Main character photo:', mainCharacter.photo);
      if (!mainCharacter.name) {
        setIsMissingInputOpen(true);
        return;
      }
      // Validate that at least main character has a photo
      if (!mainCharacter.photo) {
        //alert('Please upload a photo for the main character');
        setMessage({
          text: "Please upload a photo for the main character",
          type: "error"
        });
        return;
      }
      
      // Check if any character has a name but no photo
const charactersWithoutPhotos = characters.filter(char => char.name.trim() && !char.photo);
if (charactersWithoutPhotos.length > 0) {
  setMessage({
    text: 'Please upload photos for all named characters',
    type: 'error'
  });
  return;
}
        // Optional: Validate other characters with photos have names
  const charactersWithPhotos = characters.filter(char => char.photo);
  const unnamedPhotos = charactersWithPhotos.filter(char => !char.name);
  if (unnamedPhotos.length > 0) {
    setMessage({
      text: "Please provide names for all characters with photos",
      type: "error"
    });
   // alert('Please provide names for all characters with photos');
    return;
  }
   // Optional: Check photo file sizes again (in case user modified files)
   const oversizedPhotos = characters.filter(char => 
    char.photo && char.photo.size > 5 * 1024 * 1024
  );
  if (oversizedPhotos.length > 0) {
   // alert('Some photos are too large. Please use images under 5MB.');
    setMessage({
      text: "Some photos are too large. Please use images under 5MB.",
      type: "error"
    });
    return;
  }
  
  // Optional: Check photo file types again
  const invalidPhotos = characters.filter(char => 
    char.photo && !char.photo.type.startsWith('image/')
  );
  if (invalidPhotos.length > 0) {
   // alert('Please upload only image files (PNG, JPG, etc.)');
    setMessage({
      text: "Please upload only image files (PNG, JPG, etc.)",
      type: "error"
    });
    return;
  }
  

    
    let credit_points = 0;
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND}/user/getNumCredits`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
          },
          body: JSON.stringify(),
        }
      );
      if (!response.ok) {
        console.warn("Something wrong");
        return 0;
      }
      const result = await response.json();
      credit_points = parseInt(result);
      
    } catch (error) {
      console.error("Error", error);
      return 0;
    }
    if (credit_points < 1 || isNaN(credit_points)) {
      setAlertVisible(true);
      return;
    }
    //first make a request to backend checking the number of creadits is >=1 book,
    //if there are credits then proceed as is, otherwise throw error stating that
    //please buy credit first
    setIsConfirmationOpen(true);
    const analytics = getAnalytics(app);
    logEvent(analytics, "working_lead");
    console.log("working_lead_enhanced")
    //setCreditPoints(credit_points); // Update creditPoints state
  }
  async function handleConfirm() {
    //e.preventDefault();
    const idToken = await user.getIdToken();
    setIsLoading(true);

    const mainCharacter = characters.find(char => char.relationship === 'main') || characters[0];
    
    if (!mainCharacter) {
      //alert('No main character found');
      setMessage({
        text: "No main character found",
        type: "error"
      });
      setIsLoading(false);
      return;
    }

    setStory("");
    //setLegends("");
    setParagraphs("");
    setStoryTitle("");
   // setPrompts("");
   // setLora("");
      // Prepare all data including photos
  const formData = new FormData();
  formData.append('mainChrName', mainCharacter.name);
  formData.append('description', description);
  formData.append('moralValue', moralValue);
  formData.append('readerAgeGroup', readerAgeGroup);
  formData.append('storyType', 'Essential');
  formData.append('gender', mainCharacter.gender);           // Use character gender
  formData.append('appearanceValue', 'photo_based'); // Flag for photo-based
  
  // Add all character photos
  characters.forEach((character, index) => {
    if (character.photo) {
      formData.append(`character_${index}_photo`, character.photo);
    }
    formData.append(`character_${index}_data`, JSON.stringify({
      id: character.id,
      name: character.name,
      relationship: character.relationship,
      gender: character.gender
    }));
  });
    
    try {
      
    const response = await fetch(`${process.env.REACT_APP_BACKEND}/user/create`, {
      method: "POST",
      headers: { Authorization: idToken },
      body: formData
    });
      if (!response.ok) {
        // Backend rejected everything - no processing started
      const error = await response.text();
      if (error.includes('photo upload failed')) {
        //alert('Photo upload failed. Please try again.');
        setMessage({
          text: "Photo upload failed. Please try again.",
          type: "error"
        });
      } else {
        setIsMissingInputOpen(true);
      }
      setIsLoading(false);
      return;
    }
     
      const { bookId } = await response.json();
      setBookId(bookId);
      pollBackendForResult(bookId);
      setIsConfirmationOpen(false); // Moved inside try block
    } catch (error) {
      console.error("Error handling confirmation:", error);
      setIsLoading(false);
    }
  }

  function handleCancel(e) {
    e.preventDefault();
    console.log("Creation canceled.");
    setIsConfirmationOpen(false);
  }



  
  return (
    <div className="flex justify-center bg-slate-50">
      <div className="max-w-4xl mb-10">
        <h2 className="flex gap-x-3 mt-8 text-2xl font-bold tracking-tight text-gray-900 text-center">
          <RocketLaunchIcon
            className="mt-1 h-5 w-5 flex-none text-indigo-600"
            aria-hidden="true"
          />
          <span>
            {" "}
            Ready to unleash your creativity? Fill and submit the form below.
          </span>
        </h2>
        <div className="grid justify-center bg-slate-50">
          <form onSubmit={handleSubmit}>
            <div className="space-y-8">
               {/* Character Photos Section */}
               <CharacterPhotoUpload 
                characters={characters} 
                setCharacters={setCharacters} 
                setMessage={setMessage}
              />

              <div className="bg-white p-6 rounded-lg shadow-sm">

              <h2 className="text-base font-semibold leading-7 text-gray-900">
              Story Details
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium leading-6 text-gray-900">
                      Moral of the story
                    </label>
                    <div className="mt-2">
                      <select
                        value={moralValue}
                        onChange={(e) => setMoralValue(e.target.value)}
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      >
                        <option value=""></option>
                        <option value="courage">Courage</option>
                        <option value="honesty">Honesty</option>
                        <option value="respect">Respect</option>
                        <option value="responsibility">Responsibility</option>
                        <option value="empathy">Empathy</option>
                        <option value="compassion">Compassion</option>
                        <option value="fairness">Fairness</option>
                        <option value="gratitude">Gratitude</option>
                        <option value="cooperation">Cooperation</option>
                        <option value="generosity">Generosity</option>
                        <option value="self-discipline">Self-Discipline</option>
                        <option value="perseverance">Perseverance</option>
                        <option value="humility">Humility</option>
                        <option value="tolerance">Tolerance</option>
                        <option value="patience">Patience</option>
                        <option value="kindness">Kindness</option>
                        <option value="resilience">Resilience</option>
                        <option value="forgiveness">Forgiveness</option>
                        <option value="integrity">Integrity</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium leading-6 text-gray-900">
                      Reader's age group
                    </label>
                    <div className="mt-2">
                      <select
                        value={readerAgeGroup}
                        onChange={(e) => setReaderAgeGroup(e.target.value)}
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      >
                        <option value="2-4years">2-4 years</option>
                        <option value="5-7years">5-7 years</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="mt-6">
                  <label className="block text-sm font-medium leading-6 text-gray-900">
                    Description
                  </label>
                  <div className="mt-2">
                    <textarea
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      rows={3}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      style={{ padding: "10px" }}
                      placeholder="Tip: Include detailed storylines, actions and events with multiple characters to create a rich, engaging story!"
                    />
                  </div>
                  <p className="mt-3 text-sm leading-6 text-gray-600">
                    Write a few sentences about storyline.
                  </p>
                </div>
              </div>

              <div className="mt-6 flex items-center justify-end gap-x-6">
                <button
                  type="submit"
                  className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Generate
                </button>
              </div>
            </div>
          </form>
             {isLoading && (
            <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-50 bg-gray-800 z-50">            
            <Hourglass
              visible={true}
              height="80"
              width="80"
              ariaLabel="hourglass-loading"
              wrapperStyle={{}}
              wrapperClass=""
              colors={['#306cce', '#72a1ed']}
            />
                <p className="mt-4 text-white text-lg text-center">Your story is being generated and typically takes around 30s. Thank you for your patience!</p>
          </div>
        )}
        
        </div>
      </div>
      <Modal isOpen={alertVisible} onClose={() => setAlertVisible(false)}>
        <AlertCredit />
      </Modal>
      {/* Show the confirmation dialog if it's open */}
      {isConfirmationOpen && (
        <InputConfirmation
          onConfirm={(e) => {handleConfirm(e); setIsConfirmationOpen(false)}}
          onCancel={(e) => {handleCancel(e);  setIsConfirmationOpen(false)}}
        />
      )}
      {isMissingInputOpen && (
        <MissingInput
          onConfirm={() => setIsMissingInputOpen(false)} // Just close the dialog on confirm
        />
      )}
    </div>
  );
}
export default CreateEssential;

